<app-contract-dialog
  [(isOpen)]="dialogOpen"
  (save)="saveContract($event)"
></app-contract-dialog>
<app-card [background]="!isReadMode()" size="large">
  <ng-container *ngIf="hasContracts() && contract(); else noContracts">
    <header class="tenant-contract-header">
      <h1 class="section-title">Contract</h1>
      <app-form-action-button
        [type]="isReadMode() ? 'edit' : 'save'"
        (handleClick)="handleEdit()"
        data-test-id="tenant-contract-save-edit-button"
      />
    </header>
    <div class="tenant-contract-actions">
      <app-select-dropdown
        [optionsObj]="contractOptions()"
        [selected]="contract()._id"
        (handleSelect)="handleContractSelection($event)"
        [disabled]="!isReadMode()"
        data-test-id="tenant-contract-selector-dropdown"
      ></app-select-dropdown>
    </div>
    <app-contract-form [(contract)]="contract" [isReadMode]="isReadMode()" />
  </ng-container>
  <ng-template #noContracts>
    <div data-test-id="contracts-no-contracts-message">
      {{ 'tenantConfiguration.contracts.noContracts' | translate }}
    </div>
  </ng-template>
</app-card>
